module.exports = __webpack_public_path__ + "static/media/spicy sauce.7d6fa6f4.png";